import { StatusBadge } from '../../status-badge/status-badge.component';
import { TimelineMessageBadgeProps } from '../timeline.types';
import { useTimleineMessageStyles } from './timeline-message.styles';

export function TimelineMessage({ message, badge }: { message: string; badge?: TimelineMessageBadgeProps }) {
  const classes = useTimleineMessageStyles();

  return (
    <p className={classes.message}>
      {message}
      {badge ? (
        <StatusBadge
          className={classes.badge}
          color={badge.bgColor}
          fontSize="10px"
          label={badge.label}
          cornerRounding="min"
          collapse="wrap-text"
          inline={true}
          uppercase
          showTooltip={badge.tooltip ? true : false}
          tooltipLabel={badge.tooltip?.label}
          tooltipPlacement="bottom"
        />
      ) : null}
    </p>
  );
}
